import { unref as o, onMounted as r, nextTick as i, getCurrentInstance as l } from "vue";
function f(e) {
  return o(e) != null;
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const a = (e) => e != null;
function u(e) {
  return l();
}
function d(e, n = !0, t) {
  u() ? r(e, t) : n ? e() : i(e);
}
export {
  u as getLifeCycleTarget,
  f as isDefined,
  a as notNullish,
  d as tryOnMounted
};
